import { _ } from '@ngx-translate/core';

import { FilterStore, FilterParams } from './types';

export const DEFAULT_FILTER_STORE: Readonly<FilterStore> = {
  jobs: { title: 'field.jobTitle', type: 'checkbox', items: [], result: [] },
  businessTypes: {
    title: _('components.searchUsers.constants.businessTypes'),
    type: 'checkbox',
    items: [],
    result: [],
  },
  organizations: {
    title: 'menu.organisations',
    type: 'checkbox',
    items: [],
    result: [],
    variant: 'without-avatar',
  },
  committees: {
    title: 'menu.committees',
    type: 'checkbox',
    items: [],
    result: [],
    variant: 'full',
  },
  contacts: {
    title: _('components.searchUsers.constants.contacts'),
    type: 'field',
    items: [],
    result: [],
  },
};

export const DEFAULT_FILTER_PARAMS: Readonly<FilterParams> = {
  jobs: [],
  businessTypes: [],
  organizations: [],
  committees: [],
  contacts: [],
};
